import styled from "styled-components";
import {Select, Row, Input} from "antd";
import {CloseOutlined} from "@ant-design/icons";

export const SelectField = styled(Select)`
    width: 100%;
`;
export const FilterRow = styled(Row)`
    margin: 0 auto !important;
    padding: 10px 20px;
    position: absolute;
    z-index: 1;
    width: 100%;
    background: #ffffffbd;
`;
export const SearchInput = styled(Input.Search)`
    @media (max-width: 768px) {
        min-width: 235px;
    }
    .ant-input-group-addon {
        bottom: 3px;
        background-color: transparent;
    }
`;
export const CloseIcon = styled(CloseOutlined)`
    cursor: pointer;
`;

export const ErrorMessage = styled.div`
    color: red;
    font-size: 12px;
    margin-top: 5px;
`;
